export default __webpack_public_path__ + "static/eventbrite-0924ba7e67d373d82d964da36b0f2448.svg";